var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8031 32.172C26.6691 32.172 26.5574 32.1497 26.4233 32.0826L16.9728 27.793L7.52225 32.0826C7.23181 32.2167 6.87434 32.172 6.60625 31.9709C6.33815 31.7699 6.2041 31.4347 6.27113 31.1219L7.99144 20.8448L0.261201 13.1369C0.015452 12.8911 -0.0515705 12.556 0.0377928 12.2432C0.149497 11.9304 0.417601 11.6847 0.752728 11.64L11.0522 9.91968L16.2132 0.469158C16.3696 0.178727 16.66 0 16.9951 0C17.3302 0 17.6207 0.178727 17.7771 0.469172L22.938 9.9197L33.2375 11.64C33.5726 11.6847 33.8407 11.9305 33.9525 12.2432C34.0642 12.556 33.9748 12.9135 33.729 13.1369L26.0211 20.8448L27.7415 31.122C27.7861 31.4571 27.6744 31.7699 27.4063 31.9709C27.1829 32.105 27.0042 32.172 26.8031 32.172ZM16.9728 25.9163C17.1068 25.9163 17.2185 25.9387 17.3526 26.0057L25.6637 29.7815L24.1445 20.7107C24.0998 20.4203 24.1891 20.1298 24.3902 19.9288L31.2044 13.1146L22.2007 11.6177C21.9326 11.573 21.6869 11.3943 21.5528 11.1708L16.9728 2.77038L12.3927 11.1485C12.2587 11.3943 12.0353 11.5507 11.7448 11.5953L2.74113 13.0922L9.55534 19.9064C9.75642 20.1075 9.84579 20.3979 9.8011 20.6884L8.28187 29.7591L16.593 25.9834C16.727 25.9387 16.8387 25.9163 16.9728 25.9163Z",
    fill: "#EEC100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2cc1fb6a877c8adc4e1a616c03d3106c.svg";
export { ForwardRef as ReactComponent };